<template>
  <div id="hubHeader">
    <div class="row">

      <div class="col-2">
        <a class="pr-5" href="\">
          <!-- <b-img height="110" src="img/HeaderLeft_new.png"></b-img> -->
          <!-- <b-img height="50" src="img/gwhu.png"></b-img> -->
          <!-- <b-img height="110" src="img/logo-TfNSW-color-transparent-v2.png"></b-img> -->
          <b-img height="75" src="img/nswport_logo2.png"></b-img>
        </a>

      </div>
      <!-- </nav> -->
      <div class="col-6">
      </div>
      <div class="col-4">
        <!-- <b-img height="100" class="mt-2 mr-3" right src="img/REGIONate_RAIL_Logo.png"></b-img> -->
        <!-- <b-img height="25" class="mt-2 mr-3" right src="img/Jacobs_Logo_white.png"></b-img>
        <b-img height="25" class="mt-2 mr-3" right src="img/Arcadis_2020_black.png"></b-img> -->
      </div>
    </div>
    <!-- <b-navbar class="col-12">
      <b-navbar-brand class="col-2" href="/">
        <div class=""> -->
          <!-- <b-img id="headerImage" fluid-grow src="img/TopRibbon4_orange_white.png"></b-img> -->
          <!-- <b-img id="headerImage"  src="img/InlandRailLogo2.png"></b-img>
        </div>
      </b-navbar-brand> -->
      <!-- <nav class="navbar navbar-light bg-transparent"> -->
      <!-- <nav class="navbar"> -->
    <!-- </b-navbar> -->
  </div>
</template>
<script>
/*eslint-disable*/
  export default {
    name: 'HubHeader',
    methods: {
      logout() {
        console.log("logout clicked");
        const current = this
        current.$store.commit("mainStore/storeAccessToken", "")
        sessionStorage.removeItem("accessToken")
        current.$router.push("/")
        current.$notify({
          group: 'notification_01',
          title: 'Logout Successful',
          text: '',
          type: "success",
          duration: 1500
        });
      }
    }
  }
</script>
<style>
  #hubHeader {
    width: 100vw!important;
    height: 10vh!important;
    /* background: rgba(128, 128, 128, 0.4) */
    /* opacity: 0.5; */
  }
  .navbar {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pull-right {
    float: right !important;
  }

  .bg-graynav {
      /* background-color: #414042!important; */
      background-color: #4140423d !important;
  }
  /* #test {
    width: 100vw!important;
    height: 8vh!important;
    background-color: green;
  } */
</style>
